import Popin from './popin';

export default bookingPopin => {
    // console.log('bookingPopin');
    const dataPopin = bookingPopin.getAttribute('data-popin');
    const popin = document.querySelector(`#${dataPopin}`);
    const bookingSelects = popin.querySelectorAll('.booking-select');
    const bookingCta = popin.querySelector('#popinBookingCta');


    for(let i = 0;i<bookingSelects.length;i++){
      let bookingSelect = bookingSelects[i];
      bookingSelect.addEventListener('change', function(){
          bookingCta.setAttribute('href', bookingSelect.options[bookingSelect.selectedIndex].value);
          bookingCta.removeAttribute('disabled');
      });
    }
    bookingPopin.addEventListener('click', () => {
      if(ParamsData.floodlight != ""){
        var axel = Math.random() + "";
        var a = axel * 10000000000000;
        var htmlIframe = '<iframe src="https://10853174.fls.doubleclick.net/activityi;src=10853174;type=invmedia;cat=' + ParamsData.floodlight + ';dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=;gdpr=${GDPR};gdpr_consent=${GDPR_CONSENT_755};ord=1;num=' + a + '?" width="1" height="1" frameborder="0" style="display:none"></iframe>';
        var newNode = document.createElement('div');
        newNode.innerHTML = htmlIframe;
        var parentNode = document.querySelector('body');
        parentNode.insertBefore(newNode, parentNode.firstChild);
      }

        Popin({
            id: dataPopin,
            beforeOpen() {

            },
            afterClose() {
                bookingCta.setAttribute('disabled', '');
            },
        });
    });
};
